import React from 'react';
import { connect } from 'react-redux';
import { invalidPromocodeMessage } from '../selectors';

const stateToProps = state => ({
  invalidPromocodeMessage: invalidPromocodeMessage(state),
});

const InvalidPromoCode = props => {

    return (
      <div className="content-main table">
        <form className="reg-form table-cell">
          <div className="registration-status error">
            <p className="head--txt">Invalid link!</p>
            <p className="intro--txt mt15 ml10">
              {props.invalidPromocodeMessage}
            </p>
          </div>
        </form>
      </div>
    );
}

export default connect(
    stateToProps,
    null
)(InvalidPromoCode);
